import {useEffect} from 'react';
import CommonAppbar from '../components/common/CommonAppbar';
import Filters from '../components/Filters';
import QuestionCard from '../components/QuesAndAns/QuestionCard';
import {faker} from '@faker-js/faker';

export default function SearchResults() {

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return <>
    <CommonAppbar isMainPage={false} pageHeader={`Results for "${faker.commerce.product()}"`}/>
    <Filters/>
    <QuestionCard/>
  </>
}
